import { DataBean } from "../DataBean";

export class ProductLocationCatalog extends DataBean {


    public async getProductLocationCatalog(idProduct:any,idStore:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductLocationCatalog_Number_Number", [idProduct,idStore]);
    }

 
}